import { Select } from "../../components/select/Select";
import type { CostInvoiceStatus } from "../costApi";
import type { FC } from "react";
import { assertUnreachable } from "../../misc/utils";

const invoiceStatuses: CostInvoiceStatus[] = [
  "FOR_PAYMENT",
  "PAID",
  "ADVANCE_PAYMENT",
  "EXCESS_PAYMENT",
  "PAYMENT_IN_PROGRESS",
];

export function invoiceStatusToDisplayName(status: CostInvoiceStatus) {
  if (!status || (status as unknown) === "undefined") {
    //TODO: workaround
    return "<brak statusu>";
  }
  switch (status) {
    case "FOR_PAYMENT":
      return "Do opłacenia";
    case "PAID":
      return "Opłacona";
    case "ADVANCE_PAYMENT":
      return "Zaliczkowana";
    case "EXCESS_PAYMENT":
      return "Nadpłacona";
    case "PAYMENT_IN_PROGRESS":
      return "W płatności";
    default:
      assertUnreachable(status);
  }
}

interface Props {
  value: CostInvoiceStatus;
  onChange: (value: CostInvoiceStatus) => void;
}

const InvoiceStatusSelect: FC<Props> = ({ value, onChange }) => (
  <Select
    label="Status faktury"
    fullWidth
    value={value}
    values={
      invoiceStatuses.map((s) => ({
        value: s,
        label: invoiceStatusToDisplayName(s),
      })) ?? []
    }
    onSelect={onChange}
  />
);

export default InvoiceStatusSelect;
